/**
 * About Services
 * Centralized service for all application-related information
 */

import type { AboutType } from '@xanectech/types';
import { AppAboutInfo, createLogger } from '@xanectech/lib';

const logger = createLogger('Data - AboutService');

export class AboutService {
  private static toAboutType(data: AppAboutInfo): AboutType {
    return {
      app_name: data.app_name,
      copyright: data.copyright ?? '',
      created_at: data.created_at,
      id: String(data.id),
      info_email: data.info_email ?? '',
      is_current: data.is_current,
      privacy_policy: data.privacy_policy ?? '',
      release_notes_link: data.release_notes_link ?? '',
      release_date: data.release_date ?? '',
      terms_of_service: data.terms_of_service ?? '',
      updated_at: data.updated_at,
      version: data.version ?? '',
      contact_email: data.contact_email ?? '',
      type: data.type ?? 'XanecTech',
    };
  }

  /**
   * Get all information about the application
   */
  static async getAllAbout(): Promise<AboutType> {
    // const { data, error } = await supabase
    //   .from('about')
    //   .select('*')
    //   .eq('is_current', true)
    //   .limit(1);

    // if (error) {
    //   logger.error('Error fetching all about information', {
    //     error: getErrorMessage(error, 'AboutService.getAllAbout'),
    //   });
    //   throw error;
    // }

    const about = AppAboutInfo.find((info) => info.is_current);

    if (!about) {
      throw new Error('No current about information found');
    }

    return this.toAboutType(about);
  }

  static async getAboutByAppName(appName: string): Promise<AboutType> {
    // const { data, error } = await supabase
    //   .from('about')
    //   .select('*')
    //   .eq('app_name', appName);

    // if (error) {
    //   logger.error('Error fetching about information by app name', {
    //     error: getErrorMessage(error, 'AboutService.getAboutByAppName'),
    //   });
    //   throw error;
    // }

    // const about = data?.[0];

    // if (!about) {
    //   throw new Error(`No about information found for app: ${appName}`);
    // }
    const about = AppAboutInfo.find((info) => info.app_name === appName);

    if (!about) {
      logger.error('No about information found for app name', {
        appName,
      });
      throw new Error(`No about information found for app: ${appName}`);
    }

    return this.toAboutType(about);
  }
}
